import React, { useState } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddClientDetails = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [clientCode, setClientCode] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientNameArabic, setClientNameArabic] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [email, setEmail] = useState('');
  const [trnNo, setTrnNo] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [poBox, setPoBox] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');

  const navigate = useNavigate();

  // Static data for dropdowns
  const staticCountryData = [
    { countryId: 1, countryName: 'USA' },
    { countryId: 2, countryName: 'Canada' },
    { countryId: 3, countryName: 'UK' },
    { countryId: 4, countryName: 'Australia' },
    { countryId: 5, countryName: 'Germany' },
  ];

  const staticStateData = {
    'USA': ['California', 'Texas', 'Florida', 'New York'],
    'Canada': ['Ontario', 'Quebec', 'British Columbia', 'Alberta'],
    'UK': ['England', 'Scotland', 'Wales', 'Northern Ireland'],
    'Australia': ['New South Wales', 'Victoria', 'Queensland', 'Western Australia'],
    'Germany': ['Bavaria', 'Hesse', 'Berlin', 'Hamburg'],
  };

  const staticCityData = {
    'USA': {
      'California': ['Los Angeles', 'San Francisco', 'San Diego'],
      'Texas': ['Houston', 'Dallas', 'Austin'],
      'Florida': ['Miami', 'Orlando', 'Tampa'],
      'New York': ['New York City', 'Buffalo', 'Rochester'],
    },
    'Canada': {
      'Ontario': ['Toronto', 'Ottawa', 'Mississauga'],
      'Quebec': ['Montreal', 'Quebec City', 'Laval'],
      'British Columbia': ['Vancouver', 'Victoria', 'Kelowna'],
      'Alberta': ['Calgary', 'Edmonton', 'Red Deer'],
    },
    'UK': {
      'England': ['London', 'Manchester', 'Birmingham'],
      'Scotland': ['Edinburgh', 'Glasgow', 'Aberdeen'],
      'Wales': ['Cardiff', 'Swansea', 'Newport'],
      'Northern Ireland': ['Belfast', 'Derry', 'Lisburn'],
    },
    'Australia': {
      'New South Wales': ['Sydney', 'Newcastle', 'Wollongong'],
      'Victoria': ['Melbourne', 'Geelong', 'Ballarat'],
      'Queensland': ['Brisbane', 'Gold Coast', 'Sunshine Coast'],
      'Western Australia': ['Perth', 'Mandurah', 'Bunbury'],
    },
    'Germany': {
      'Bavaria': ['Munich', 'Nuremberg', 'Augsburg'],
      'Hesse': ['Frankfurt', 'Wiesbaden', 'Darmstadt'],
      'Berlin': ['Berlin', 'Potsdam', 'Brandenburg'],
      'Hamburg': ['Hamburg', 'Altona', 'Harburg'],
    },
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (clientCode && clientName && mobileNo && email && trnNo && country && state && city && poBox && address && description) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setClientCode('');
    setClientName('');
    setClientNameArabic('');
    setMobileNo('');
    setEmail('');
    setTrnNo('');
    setCountry('');
    setState('');
    setCity('');
    setPoBox('');
    setAddress('');
    setDescription('');
  };

  const handleClientDetails = () => {
    alert('Client Details button clicked');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Client Details
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Client Code"
              variant="outlined"
              fullWidth
              value={clientCode}
              onChange={(e) => setClientCode(e.target.value)}
            />
            <TextField
              label="Client Name"
              variant="outlined"
              fullWidth
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Client Name (Arabic)"
              variant="outlined"
              fullWidth
              value={clientNameArabic}
              onChange={(e) => setClientNameArabic(e.target.value)}
            />
            <TextField
              label="Mobile No."
              variant="outlined"
              fullWidth
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label="TRN No."
              variant="outlined"
              fullWidth
              value={trnNo}
              onChange={(e) => setTrnNo(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                value={country}
                label="Country"
                onChange={(e) => {
                  setCountry(e.target.value);
                  setState('');
                  setCity('');
                }}
              >
                {staticCountryData.map((country) => (
                  <MenuItem key={country.countryId} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                id="state"
                value={state}
                label="State"
                onChange={(e) => {
                  setState(e.target.value);
                  setCity('');
                }}
                disabled={!country}
              >
                {country && staticStateData[country]?.map((stateItem) => (
                  <MenuItem key={stateItem} value={stateItem}>
                    {stateItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="city-label">City</InputLabel>
              <Select
                labelId="city-label"
                id="city"
                value={city}
                label="City"
                onChange={(e) => setCity(e.target.value)}
                disabled={!state}
              >
                {state && country && staticCityData[country]?.[state]?.map((cityItem) => (
                  <MenuItem key={cityItem} value={cityItem}>
                    {cityItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="PO Box"
              variant="outlined"
              fullWidth
              value={poBox}
              onChange={(e) => setPoBox(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
           
            <Box>
              <Tooltip title={
                !clientCode ? "Enter Client Code" :
                !clientName ? "Enter Client Name" :
                !mobileNo ? "Enter Mobile No." :
                !email ? "Enter Email" :
                !trnNo ? "Enter TRN No." :
                !country ? "Select Country" :
                !state ? "Select State" :
                !city ? "Select City" :
                !poBox ? "Enter PO Box" :
                !address ? "Enter Address" :
                !description ? "Enter Description" : ""
              } arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      mr: 2,
                      backgroundColor: '#127498ff',
                      '&:hover': { backgroundColor: '#116280ff' }
                    }}
                    disabled={!clientCode || !clientName || !mobileNo || !email || !trnNo || !country || !state || !city || !poBox || !address || !description}
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Client Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Client Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddClientDetails;
